var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.node
    ? _c("li", { staticClass: "node" }, [
        _vm.node.label
          ? _c(
              "a",
              {
                class: { selected: _vm.sectionId == _vm.node.id },
                attrs: { href: "/catalog/" + _vm.node.id + "/" },
              },
              [
                _vm.node.children
                  ? _c(
                      "span",
                      {
                        staticClass: "sign",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.showTree.apply(null, arguments)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.sign))]
                    )
                  : _vm._e(),
                _c("span", { staticClass: "label" }, [
                  _vm._v(_vm._s(_vm.node.label)),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.node.children
          ? _c(
              "ul",
              {
                staticClass: "node-tree",
                class: { open: _vm.isShowTree || !_vm.node.label },
              },
              _vm._l(_vm.node.children, function (child) {
                return _c("node", {
                  key: child.id,
                  attrs: { node: child, level: _vm.level + 1 },
                })
              }),
              1
            )
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }